var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._g({staticClass:"llm-add-param-btn",attrs:{"type":"text","disabled":_vm.disabled}},_vm.$listeners),[_vm._v(" + 添加参数 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }